import clsx from 'clsx'
import { KTSVG } from '_metronic/helpers'
import { JobClosingLineType } from '../types'

export interface FormLine {
  clientId: string
  sequence: number
  lineType: JobClosingLineType
  inventoryCode?: string
  quantity?: number
  length?: number | null
  description?: string
  amount?: number | null
}

interface Props {
  line: FormLine
  index: number
  disabled?: boolean
  onChange: (line: FormLine) => void
  onRemove: () => void
}

const JobClosingLineRow: React.FC<Props> = ({
  line,
  index,
  disabled,
  onChange,
  onRemove,
}) => {
  const isPile = line.lineType === 'pile'

  return (
    <tr>
      <td className='text-center align-middle'>{index + 1}</td>
      <td className='align-middle'>
        <span
          className={clsx('badge', {
            'badge-light-primary': isPile,
            'badge-light-warning': !isPile,
          })}>
          {isPile ? 'เสา' : 'ค่าใช้จ่าย'}
        </span>
      </td>
      <td className='align-middle'>
        {isPile ? (
          <div className='d-flex flex-wrap gap-2'>
            <input
              type='text'
              className='form-control form-control-sm'
              style={{ minWidth: 160, flex: 1 }}
              placeholder='ชนิด/ขนาดเสา'
              value={line.inventoryCode ?? ''}
              disabled={disabled}
              onChange={e => onChange({ ...line, inventoryCode: e.target.value })}
            />
            <div className='d-flex align-items-center gap-1' style={{ width: 140 }}>
              <input
                type='number'
                min={0}
                step='any'
                className='form-control form-control-sm'
                placeholder='ความยาว'
                value={line.length ?? ''}
                disabled={disabled}
                onChange={e =>
                  onChange({
                    ...line,
                    length: e.target.value ? Number(e.target.value) : null,
                  })
                }
              />
              <span className='text-muted fs-8 text-nowrap'>ม.</span>
            </div>
          </div>
        ) : (
          <input
            type='text'
            className='form-control form-control-sm'
            placeholder='รายละเอียดค่าใช้จ่าย'
            value={line.description ?? ''}
            disabled={disabled}
            onChange={e =>
              onChange({
                ...line,
                description: e.target.value,
              })
            }
          />
        )}
      </td>
      <td className='align-middle' style={{ width: 100 }}>
        {isPile ? (
          <input
            type='number'
            min={1}
            step={1}
            className='form-control form-control-sm'
            value={line.quantity ?? 1}
            disabled={disabled}
            onChange={e =>
              onChange({
                ...line,
                quantity: Math.max(1, Math.round(Number(e.target.value) || 1)),
              })
            }
          />
        ) : (
          <input
            type='number'
            min={1}
            step={1}
            className='form-control form-control-sm'
            value={line.amount ?? 1}
            disabled={disabled}
            onChange={e =>
              onChange({
                ...line,
                amount: Math.max(1, Math.round(Number(e.target.value) || 1)),
              })
            }
          />
        )}
      </td>
      <td className='text-center align-middle' style={{ width: 60 }}>
        <button
          type='button'
          className='btn btn-sm btn-icon btn-light-danger'
          disabled={disabled}
          onClick={onRemove}
          title='ลบแถว'>
          <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
        </button>
      </td>
    </tr>
  )
}

export default JobClosingLineRow
